import type { RoadmapType } from '@atlassian/jira-software-roadmap-model/src/app/index.tsx';

export const toRoadmapSpaAppId = (type: RoadmapType) => `spa-apps.roadmap.${type}`.toLowerCase();
